//Imports
import {
  STAFF_PLANNER_LIST_REQUEST,
  STAFF_PLANNER_LIST_SUCCESS,
  STAFF_PLANNER_LIST_FAIL,
  STAFF_PLANNER_DATA_REQUEST,
  STAFF_PLANNER_DATA_SUCCESS,
  STAFF_PLANNER_DATA_FAIL,
  STAFF_PLANNER_CREATE_REQUEST,
  STAFF_PLANNER_CREATE_SUCCESS,
  STAFF_PLANNER_CREATE_FAIL,
  STAFF_PLANNER_UPDATE_REQUEST,
  STAFF_PLANNER_UPDATE_SUCCESS,
  STAFF_PLANNER_UPDATE_FAIL,
  STAFF_PLANNER_DELETE_REQUEST,
  STAFF_PLANNER_DELETE_SUCCESS,
  STAFF_PLANNER_DELETE_FAIL,
  STAFF_PLANNER_SEARCH_REQUEST,
  STAFF_PLANNER_SEARCH_SUCCESS,
  STAFF_PLANNER_SEARCH_FAIL,
  STAFF_PLANNER_COMPLETE_REQUEST,
  STAFF_PLANNER_COMPLETE_SUCCESS,
  STAFF_PLANNER_COMPLETE_FAIL,
  STAFF_PLANNER_UNINVOICED_REQUEST,
  STAFF_PLANNER_UNINVOICED_SUCCESS,
  STAFF_PLANNER_UNINVOICED_FAIL,
  STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST,
  STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS,
  STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL,
  STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST,
  STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS,
  STAFF_PLANNER_GENERATE_RECURRENCE_FAIL,
  STAFF_PLANNER_STATUS_LIST_REQUEST,
  STAFF_PLANNER_STATUS_LIST_SUCCESS,
  STAFF_PLANNER_STATUS_LIST_FAIL,
  STAFF_PLANNER_RECENT_ACTIVITY_REQUEST,
  STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS,
  STAFF_PLANNER_RECENT_ACTIVITY_FAIL,
  STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_LIST_FAIL,
  STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_DATA_FAIL,
  STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL,
} from "./actionType";

//Actions

//STAFF_PLANNER_LIST_REQUEST
export const staffPlannerListRequest = () => ({
  type: STAFF_PLANNER_LIST_REQUEST,
});
//STAFF_PLANNER_LIST_SUCCESS
export const staffPlannerListSuccess = (data) => ({
  type: STAFF_PLANNER_LIST_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_LIST_FAIL
export const staffPlannerListFail = (error) => ({
  type: STAFF_PLANNER_LIST_FAIL,
  payload: error,
});
//STAFF_PLANNER_DATA_REQUEST
export const staffPlannerDataRequest = (id) => ({
  type: STAFF_PLANNER_DATA_REQUEST,
  payload: id,
});
//STAFF_PLANNER_DATA_SUCCESS
export const staffPlannerDataSuccess = (data) => ({
  type: STAFF_PLANNER_DATA_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_DATA_FAIL
export const staffPlannerDataFail = (error) => ({
  type: STAFF_PLANNER_DATA_FAIL,
  payload: error,
});
//STAFF_PLANNER_CREATE_REQUEST
export const staffPlannerCreateRequest = (data) => ({
  type: STAFF_PLANNER_CREATE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_CREATE_SUCCESS
export const staffPlannerCreateSuccess = (data) => ({
  type: STAFF_PLANNER_CREATE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_CREATE_FAIL
export const staffPlannerCreateFail = (error) => ({
  type: STAFF_PLANNER_CREATE_FAIL,
  payload: error,
});
//STAFF_PLANNER_UPDATE_REQUEST
export const staffPlannerUpdateRequest = (data) => ({
  type: STAFF_PLANNER_UPDATE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_UPDATE_SUCCESS
export const staffPlannerUpdateSuccess = (data) => ({
  type: STAFF_PLANNER_UPDATE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_UPDATE_FAIL
export const staffPlannerUpdateFail = (error) => ({
  type: STAFF_PLANNER_UPDATE_FAIL,
  payload: error,
});
//STAFF_PLANNER_DELETE_REQUEST
export const staffPlannerDeleteRequest = (id) => ({
  type: STAFF_PLANNER_DELETE_REQUEST,
  payload: id,
});
//STAFF_PLANNER_DELETE_SUCCESS
export const staffPlannerDeleteSuccess = (data) => ({
  type: STAFF_PLANNER_DELETE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_DELETE_FAIL
export const staffPlannerDeleteFail = (error) => ({
  type: STAFF_PLANNER_DELETE_FAIL,
  payload: error,
});
//STAFF_PLANNER_SEARCH_REQUEST
export const staffPlannerSearchRequest = (data) => ({
  type: STAFF_PLANNER_SEARCH_REQUEST,
  payload: data,
});
//STAFF_PLANNER_SEARCH_SUCCESS
export const staffPlannerSearchSuccess = (data) => ({
  type: STAFF_PLANNER_SEARCH_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_SEARCH_FAIL
export const staffPlannerSearchFail = (error) => ({
  type: STAFF_PLANNER_SEARCH_FAIL,
  payload: error,
});
//STAFF_PLANNER_COMPLETE_REQUEST
export const staffPlannerCompleteRequest = (data) => ({
  type: STAFF_PLANNER_COMPLETE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_COMPLETE_SUCCESS
export const staffPlannerCompleteSuccess = (data) => ({
  type: STAFF_PLANNER_COMPLETE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_COMPLETE_FAIL
export const staffPlannerCompleteFail = (error) => ({
  type: STAFF_PLANNER_COMPLETE_FAIL,
  payload: error,
});
//STAFF_PLANNER_UNINVOICED_REQUEST
export const staffPlannerUninvoicedRequest = (data) => ({
  type: STAFF_PLANNER_UNINVOICED_REQUEST,
  payload: data,
});
//STAFF_PLANNER_UNINVOICED_SUCCESS
export const staffPlannerUninvoicedSuccess = (data) => ({
  type: STAFF_PLANNER_UNINVOICED_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_UNINVOICED_FAIL
export const staffPlannerUninvoicedFail = (error) => ({
  type: STAFF_PLANNER_UNINVOICED_FAIL,
  payload: error,
});
//STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST
export const staffPlannerConvertToInvoiceRequest = (data) => ({
  type: STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS
export const staffPlannerConvertToInvoiceSuccess = (data) => ({
  type: STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL
export const staffPlannerConvertToInvoiceFail = (error) => ({
  type: STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL,
  payload: error,
});
//STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST
export const staffPlannerGenerateRecurrenceRequest = (data) => ({
  type: STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS
export const staffPlannerGenerateRecurrenceSuccess = (data) => ({
  type: STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_GENERATE_RECURRENCE_FAIL
export const staffPlannerGenerateRecurrenceFail = (error) => ({
  type: STAFF_PLANNER_GENERATE_RECURRENCE_FAIL,
  payload: error,
});
//STAFF_PLANNER_STATUS_LIST_REQUEST
export const staffPlannerStatusListRequest = () => ({
  type: STAFF_PLANNER_STATUS_LIST_REQUEST,
});
//STAFF_PLANNER_STATUS_LIST_SUCCESS
export const staffPlannerStatusListSuccess = (data) => ({
  type: STAFF_PLANNER_STATUS_LIST_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_STATUS_LIST_FAIL
export const staffPlannerStatusListFail = (error) => ({
  type: STAFF_PLANNER_STATUS_LIST_FAIL,
  payload: error,
});
//STAFF_PLANNER_RECENT_ACTIVITY_REQUEST
export const staffPlannerRecentActivityRequest = (data) => ({
  type: STAFF_PLANNER_RECENT_ACTIVITY_REQUEST,
  payload: data,
});
//STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS
export const staffPlannerRecentActivitySuccess = (data) => ({
  type: STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_RECENT_ACTIVITY_FAIL
export const staffPlannerRecentActivityFail = (error) => ({
  type: STAFF_PLANNER_RECENT_ACTIVITY_FAIL,
  payload: error,
});
//STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST
export const staffPlannerAssignmentListRequest = () => ({
  type: STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST,
});
//STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS
export const staffPlannerAssignmentListSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_LIST_FAIL
export const staffPlannerAssignmentListFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_LIST_FAIL,
  payload: error,
});
//STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST
export const staffPlannerAssignmentDataRequest = (id) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST,
  payload: id,
});
//STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS
export const staffPlannerAssignmentDataSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_DATA_FAIL
export const staffPlannerAssignmentDataFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DATA_FAIL,
  payload: error,
});
//STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST
export const staffPlannerAssignmentCreateRequest = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS
export const staffPlannerAssignmentCreateSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL
export const staffPlannerAssignmentCreateFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL,
  payload: error,
});
//STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST
export const staffPlannerAssignmentUpdateRequest = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS
export const staffPlannerAssignmentUpdateSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL
export const staffPlannerAssignmentUpdateFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL,
  payload: error,
});
//STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST
export const staffPlannerAssignmentDeleteRequest = (id) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST,
  payload: id,
});
//STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS
export const staffPlannerAssignmentDeleteSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL
export const staffPlannerAssignmentDeleteFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL,
  payload: error,
});

//STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST
export const staffPlannerAssignmentAssignRequest = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS
export const staffPlannerAssignmentAssignSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL
export const staffPlannerAssignmentAssignFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL,
  payload: error,
});

//STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST
export const staffPlannerAssignmentUnassignRequest = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS
export const staffPlannerAssignmentUnassignSuccess = (data) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS,
  payload: data,
});
//STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL
export const staffPlannerAssignmentUnassignFail = (error) => ({
  type: STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL,
  payload: error,
});
